import { createFileRoute } from '@tanstack/react-router'
import { StatsPage } from '~/features/admin/stats-page'

export const Route = createFileRoute('/admin/stats')({
  component: StatsPage,
})
